module.exports = __webpack_public_path__ + "img/follow.90138b2f.png";